import { Box, createStyles, makeStyles } from '@material-ui/core'
import React, { useMemo, useState } from 'react'
import { Colors, DynamicMuiIcon, SvgIcon, Tooltip, Typography } from 'src/components/atoms'
import VariadicSelectBox from 'src/components/atoms/VariadicSelectBox'
import { ShareLinkFormSection } from 'src/components/molecules/ShareLinkFormSection'
import { useListSelectorUsersList } from 'src/fixtures/modules/selector/hooks'

export interface ShareLinkFormUserSelectSectionProps {
  values: string[]
  onChange: (notificationUserIds: string[]) => void
}

const useStyles = makeStyles(() => {
  return createStyles({
    avatarImg: {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      position: 'absolute',
      top: 0,
      left: 0,
      objectFit: 'cover'
    }
  })
})

export const ShareLinkFormNotificationUserSelectSection = ({
  values,
  onChange
}: ShareLinkFormUserSelectSectionProps) => {
  const { data: selectorUserRes } = useListSelectorUsersList({ page: 1, per: 9999 })
  const [fields, setFields] = useState(values)

  const selectorUserList = selectorUserRes?.selectorItems
  const classes = useStyles()
  const userOptionList = useMemo(() => {
    return (
      selectorUserList?.map(item => ({
        value: item.id!,
        label: item.text,
        startElement: (
          <Box width="20px" height="20px" mr="4px" position="relative">
            {item.extend?.avatar ? (
              <img src={item.extend.avatar.url} className={classes.avatarImg} />
            ) : (
              <SvgIcon variant="avatar" size="20px" color={Colors.base.middleGray} />
            )}
          </Box>
        )
      })) || []
    )
  }, [selectorUserList, classes.avatarImg])

  const changeField = (index: number, fieldValue: string | number) => {
    if (typeof fieldValue !== 'string') return // 型ガード
    if (fields.includes(fieldValue)) return // 重複チェック
    setFields(prevState => {
      const newFields = [...prevState]
      newFields[index] = fieldValue
      onChange(newFields)
      return newFields
    })
  }

  const addField = () => setFields(prevState => [...prevState, ''])

  const removeField = (index: number) =>
    setFields(prevState => {
      const prevSelectedLength = prevState.filter(field => field !== '').length
      const newFields = prevState.filter((_, i) => i !== index)
      const newSelectedLength = newFields.filter(field => field !== '').length
      // 選択済みのフォームを削除した場合のみ更新
      if (prevSelectedLength > newSelectedLength) {
        onChange(newFields)
      }
      return newFields
    })

  return (
    <ShareLinkFormSection>
      <Box display="flex" alignItems="center" mb="8px">
        <Typography variant="h6" fontSize="s" lineheight="14px">
          通知メール送信先設定
        </Typography>
        <Box mr="6px" />
        <Tooltip content={'資料閲覧時の通知メール送信先を設定できます。'} maxWidth={'none'}>
          <DynamicMuiIcon variant="helpRounded" color="action" size="16px" />
        </Tooltip>
      </Box>
      <Box width={0.6}>
        <VariadicSelectBox
          values={fields}
          onChange={changeField}
          addField={addField}
          removeField={removeField}
          optionList={userOptionList}
          placeholder="選択してください"
          height="34px"
          limit={5}
        />
      </Box>
    </ShareLinkFormSection>
  )
}
